<template>
  <router-view v-if="billPage"/>
  <TemplateView v-else>
    <TemplatePage :loading="loading">
      <div class="container">
        <StatisticProjectReportsBlank
          v-if="showData && showData.data"
          :data="showData"
          :weeks="showSelectedWeeks"
          :on-report-show="onWorkClientProjectsPeriodReportShow"
          :on-report-update="onWorkClientProjectsPeriodReportUpdate"
        />
        <Plug v-if="noData"/>
      </div>
    </TemplatePage>
  </TemplateView>
</template>

<script>
import TemplateView from 'components/templates/TemplateView'
import StatisticProjectReportsBlank from 'components/timeControl/reports/StatisticProjectReportsBlank'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import Plug from "../../../components/Plug";

export default {
  name: 'timeControlShowReportsView',
  components: {
    Plug,
    TemplateView,
    StatisticProjectReportsBlank,
  },
  data: () => ({
    numberOfTasks: 0,
    numberOfAdded: 0,
    documents: [],
    generateMultiple: false,
    refActive: null,
    loading: true,
    noData: false
  }),
  created() {
    this.onFirstLoad()
  },
  computed: {
    ...mapGetters('workClientProjectsPeriodReport', ['workClientProjectsPeriodReportShow']),
    ...mapGetters('guest_periodReport', ['guest_periodReport__show']),
    billPage() {
      return this.$route.name === 'timeControlShowReportsViewBill'
    },
    showData() {
      return this.workClientProjectsPeriodReportShow
      // return this.$route.name === 'linkProjectReportSign'
      //     ? this.guest_periodReport__show
      //     : this.workClientProjectsPeriodReportShow
    },
    selectedDates() {
      let obj = {}
      obj.dates = this.$getDates(
        new Date(this.showData.start_date),
        new Date(this.showData.end_date),
      )
      obj.weeks = []
      for (let date of obj.dates) {
        if (!obj.weeks.find((i) => i === date.getWeek())) obj.weeks.push(date.getWeek())
      }
      return obj
    },
    showSelectedWeeks() {
      let string = ''
      if (this.selectedDates.weeks) {
        for (let week in this.selectedDates.weeks) {
          if (week == 0) {
            string = string + this.selectedDates.weeks[week]
          } else {
            string = string + ', ' + this.selectedDates.weeks[week]
          }
        }
      }
      return string
    },
  },
  methods: {
    ...mapActions('workClientProject', ['onWorkClientProjectStatistic']),
    ...mapActions('workClientProjectsPeriodReport', ['onWorkClientProjectsPeriodReportShow']),
    ...mapActions('workClientProjectsPeriodReportUpdate', ['onWorkClientProjectsPeriodReportUpdate']),
    ...mapMutations('workClientProjectsPeriodReport', ['setWorkClientProjectsPeriodReportShow']),
    //...mapActions('guest_periodReport', ['ON_guest_periodReport__show']),
    async onFirstLoad() {
      // if (this.$route.name === 'linkProjectReportSign') {
      //     await this.ON_guest_periodReport__show(this.$route.params.hash).catch(
      //         () => this.$router.push({name: '404'}),
      //     )
      // } else {
      //     await this.onWorkClientProjectStatistic(this.$route.params.id)
      //     await this.onWorkClientProjectsPeriodReportShow(this.$route.params.report_id).catch(error => {
      //         this.noData = true
      //     })
      // }
      await this.onWorkClientProjectStatistic(this.$route.params.id)
      await this.onWorkClientProjectsPeriodReportShow(this.$route.params.report_id).catch(error => {
        this.noData = true
      })
      this.loading = false
    }
  },
  destroyed() {
    this.setWorkClientProjectsPeriodReportShow(null)
  },
}
</script>
